<template>
  <div>
    <div>
      <div>

        <div class="d-flex flex-column feedback-container">
          <div class="d-flex flex-column gap-5">
            <div class="font-size-150 d-inline-flex align-items-center gap-10px"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g fill="none" fill-rule="evenodd">
                <path
                    d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/>
                <path fill="currentColor"
                      d="m20.255 5.52l.087.298l.089.338l.044.185l.089.4l.085.443l.081.485c.026.169.05.345.074.528l.065.572c.08.791.131 1.7.131 2.731s-.05 1.94-.13 2.731l-.066.572c-.023.183-.048.36-.074.528l-.08.485l-.086.443l-.089.4l-.089.36l-.088.317l-.043.144c-.331 1.087-1.464 1.505-2.394 1.195l-1.18-.393l-.4.933a2 2 0 0 1-2.47 1.11l-5.096-1.7a2 2 0 0 1-1.206-2.684l.269-.628L7 15.055l-1.368.456A2 2 0 0 1 3 13.613V9.388A2 2 0 0 1 5.632 7.49L7 7.946l10.861-3.62c.93-.31 2.063.107 2.394 1.194M9.682 15.948l-.335.78l5.096 1.7l.335-.781zm8.706-9.69L8 9.721v3.558l10.388 3.463l.077-.283l.08-.327l.04-.18l.078-.394a17.8 17.8 0 0 0 .076-.439l.07-.485c.112-.847.191-1.887.191-3.134c0-1.246-.08-2.287-.19-3.134l-.071-.485c-.025-.154-.05-.3-.076-.44l-.079-.393l-.08-.349zM5 9.388v4.225l1-.334V9.721z"/>
              </g>
            </svg> {{ 'Your input matters!' | trans }}</div>
            <p>{{
                'Share your thoughts, suggestions, or experiences using our services.' | trans
              }}</p>
            <p>{{
                'Your feedback helps us improve.' | trans
              }}
              {{
                'Thank you for being a part of our journey!' | trans
              }}</p>
          </div>
          <div class="d-flex flex-column gap-10">
            <strong>{{ 'How would you rate us?' | trans }}</strong>
            <div class="d-flex gap-15">
              <label
                  :class="{ 'disabled': currentJob.feedback.loading === true || currentJob.feedback.submittedFull === true}"
                  class="radio-inline ">
                <input type="radio" v-model="rating" value="5" class="feedback-btn-star-5" />
                {{ 'Great' | trans }}
              </label>
              <label
                  :class="{ 'disabled': currentJob.feedback.loading === true || currentJob.feedback.submittedFull === true}"
                  class="radio-inline">
                <input type="radio" v-model="rating" value="4"/>
                {{ 'Good' | trans }}
              </label>
              <label
                  :class="{ 'disabled': currentJob.feedback.loading === true || currentJob.feedback.submittedFull === true}"
                  class="radio-inline">
                <input type="radio" v-model="rating" value="3"/>
                {{ 'Medium' | trans }}
              </label>
              <label
                  :class="{ 'disabled': currentJob.feedback.loading === true || currentJob.feedback.submittedFull === true}"
                  class="radio-inline">
                <input type="radio" v-model="rating" value="2"/>
                {{ 'Bad' | trans }}
              </label>
              <label
                  :class="{ 'disabled': currentJob.feedback.loading === true || currentJob.feedback.submittedFull === true}"
                  class="radio-inline">
                <input type="radio" v-model="rating" value="1"/>
                {{ 'Worse' | trans }}
              </label>
            </div>
          </div>

          <div class="alert alert-warning" v-if="selectRatingError">
            {{ 'Please enter a rating before submitting your feedback!' | trans }}
          </div>

          <TextArea
              v-model="message"
              :border-class="'br-4'"
              :label="placeholder"
              :max-characters="4000"
              :rows="'4'"
              :value="message"
              :aiCustom="true"
              :class="{ 'disabled': currentJob.feedback.loading === true || currentJob.feedback.submittedFull === true}"
              :disabled="currentJob.feedback.loading === true || currentJob.feedback.submittedFull === true"
              class="w-100 feedback-text-area"
              name="prompt"
              :id="'feedback-form-textarea'"
              type="text"
          ></TextArea>
          <div class="alert alert-info" v-if="currentJob.feedback.loading === true">
            {{ 'Submitting your feedback..' | trans }}
          </div>
          <div class="alert alert-info feedback-info" v-if="currentJob.feedback.submittedFull === true">
            {{ 'Thank you for giving us your feedback.' | trans }}
          </div>

          <div>
            <button id="feedback-submit-btn-main" class="btn" @click.prevent="send"
                    :class="{ 'disabled': currentJob.feedback.loading === true || currentJob.feedback.submittedFull === true}">


              <strong> {{ 'Submit' | trans }}</strong>
              <i v-if="!currentJob.feedback.loading" class="fa fa-arrow-right"></i>
              <i v-if="currentJob.feedback.loading" class="fa fa-spin btn-loading-animation"></i>
            </button>
          </div>

        </div>



    </div>
    </div>
  </div>
</template>
<script>
import FeedbackManager from "../../manager/FeedbackManager";
import TextArea from "../../../form/TextArea.vue";
import {translate} from "../../../../../../helper/translate";
import currentJob from "../../mixins/current_job.mixin";
import store from "../../mixins/store.mixin";
import Analytics from "../../util/Analytics";

export default {
  name: 'FeedbackFull',
  props: {},
  components: {TextArea},
  mixins: [
    currentJob,
    store
  ],
  data() {
    return {
      selectRatingError: false,
      rating: null,
      message: '',
      placeholder: translate('Something you want to tell us? (optional)')
    };
  },
  mounted: function () {
  },
  created: function () {
    if (this.currentJob.feedback.rating !== null) {
      this.rating = this.currentJob.feedback.rating;
    }
  },
  methods: {
    async send() {
      this.selectRatingError = false;

      if (null === this.rating || this.rating === 0) {
        this.selectRatingError = true;
        return;
      }
      if (this.currentJob.feedback.submittedFull === true) {
        return;
      }

      Analytics.send('result_feedback', 'rating_full', this.currentJob);

      await FeedbackManager.submitFeedback(this.currentJob, this.rating, this.message, 'ai_inpainting', 'no_id');
      this.currentJob.feedback.submittedFull = true;
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.feedback-container {
  color: black;
  gap: 20px;
}
.disabled {
  cursor: not-allowed;
}

p {
  margin: 0;
}

.styled-text-area {
  padding-bottom: 3px;
  border-radius: 9px;
  background: #fff;
  color: #2e2e2e;
  position: relative;

  textarea {
    font-size: 18px !important;
    margin: 40px 20px 20px 20px !important;
    padding: 0;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}


  img {
    width: 100%;
    height: auto;
  }

  .feedback-text-area {
    padding-bottom: 3px;
    background: #fff;
    color: #2e2e2e;
    position: relative;
    border-radius: 5px;
    border: 1px solid #CBCBCB;

    textarea {
      font-size: 18px !important;
      margin: 40px 20px 0 20px !important;
      padding: 0;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
  }


  .modal-dialog {
    width: 599px;
    max-width: 95%;
    border-radius: 9px;
    overflow: hidden;
  }

  .close-btn {
    background: #d9d9d9;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
  }


#feedback-submit-btn-main {
    background: #1266F1;
    color: white;
    align-items: center;
    display: flex;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
  }

  .premium-btn {
    background-color: #ffaa00;
    height: 38px;
    gap: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
    padding: 0 10px 0 10px;
  }

  .modal-content-title {
    font-size: 28px;
    font-weight: 600;
  }

  .modal-content {
    h2 {
      margin-top: 0;
    }

    font-size: 17.5px;
    border: 1px solid #ccc;

    p {
      font-size: 17.5px;
    }
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    display: flex;
    padding: 10px 10px;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background: #f8f9fa;

    .btn {
      margin: 0;
    }
  }

</style>
